import React from 'react';

const BracketHeader = ({ title, subtitle, className }) => {
  return (
    <>
      <div className={`bracket-header ${className}`}>
        <div className="bracket-wrapper left">
          <div className="outer-hook"></div>
          <div className="inner-line"></div>
        </div>

        <div className="text-content">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>

        <div className="bracket-wrapper right">
          <div className="inner-line"></div>
          <div className="outer-hook"></div>
        </div>
      </div>
    </>
  );
};

export default BracketHeader;